import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esDepression } from "@/pages/es/esConditionData1";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/depression-treatment-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esDepression),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esDepression} />;
}
